import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getOrderGeneratorsFieldsWorksExecutors(companyId, generatorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].getOrderGeneratorsFieldsWorksExecutors,
		{
			urlParams: {
				companyId,
        generatorId,
			},
		}
	)
}

function getOrderGeneratorsFieldsWorksExecutor(companyId, generatorId, executorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].getOrderGeneratorsFieldsWorksExecutor,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
			},
		}
	)
}

function createOrderGeneratorsFieldsWorksExecutor(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].createOrderGeneratorsFieldsWorksExecutor,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}
function createOrderGeneratorsFieldsWorksExecutorBulk(companyId, generatorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].createOrderGeneratorsFieldsWorksExecutorBulk,
		{
			urlParams: {
				companyId,
        generatorId,
			},
			...payload,
		}
	)
}


function putOrderGeneratorsFieldsWorksExecutor(companyId, generatorId, executorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].putOrderGeneratorsFieldsWorksExecutor,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
			},
			...payload,
		}
	)
}

function patchOrderGeneratorsFieldsWorksExecutor(companyId, generatorId, executorId, payload) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].patchOrderGeneratorsFieldsWorksExecutor,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
			},
			...payload,
		}
	)
}

function deleteOrderGeneratorsFieldsWorksExecutor(companyId, generatorId, executorId) {
	return dataTransferWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS,
		dtConfig[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS].deleteOrderGeneratorsFieldsWorksExecutor,
		{
			urlParams: {
				companyId,
        generatorId,
				executorId,
			},
		}
	)
}

export default {
	getOrderGeneratorsFieldsWorksExecutors,
	getOrderGeneratorsFieldsWorksExecutor,
	createOrderGeneratorsFieldsWorksExecutor,
	createOrderGeneratorsFieldsWorksExecutorBulk,
	putOrderGeneratorsFieldsWorksExecutor,
	patchOrderGeneratorsFieldsWorksExecutor,
	deleteOrderGeneratorsFieldsWorksExecutor,
}

